import { MyFirebaseList } from './../../providers/my-firebase-list';

import { MyFirebase } from './../../providers/my-firebase';
import { ElePage } from './../ele/ele';
import { Component } from '@angular/core';
import { ActionSheetController, AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';

import firebase from 'firebase';

/**
 * Eles page, Crud base class.
 *
 */
@IonicPage()
@Component({ 
  selector: 'page-eles',
  templateUrl: 'eles.html',
})
export class ElesPage extends ElePage {

  
  // Ref Firebase list  
  public elesRef; //  = firebase.database().ref('/eles');

  public childrenRef; // = firebase.database().ref('/eles/children');


  // Manage order, dans ui avec button <button ion-button icon-only (click)="reorder = !reorder">

// Callback add, ou page add
// Callback update, ou page upadte

  // Add page
  addPage : any; // = ElePage;

  // Update page
  updatePage : any; // = ElePage;



  // Filter
  doFilterRegExp = null;

  doFilter(ele, index, array) :boolean {

    if (this.doFilterRegExp == null) return true;
    if ( ele.value.email == null) return true;
    try { 
      if (this.doFilterRegExp instanceof String) return ele.value.email.search( this.doFilterRegExp ) != -1;
      return this.doFilterRegExp.test(ele.value.email);
    } catch(e) {  }

    return true;
  }


  myList : MyFirebaseList;


  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public alertCtrl: AlertController, public actionSheetCtrl: ActionSheetController,
              public myFirebase : MyFirebase) {

    super(navCtrl, navParams);
  
  }



  ionViewDidLoad() {
    console.log('ionViewDidLoad ElesPage');
 this.myList = this.myFirebase.getList(this.elesRef, this.childrenRef);
   
  }
 
  ionViewWillUnload() {
    console.log('ionViewWillUnload ElesPage');

    this.myList.end();
  }

  
  

  onAdd(){
    this.navCtrl.push(this.addPage, {parent:this, eleId: null, ele:null });
  }

  onUpdate(eleId, ele){
    this.navCtrl.push(this.updatePage, {parent:this, eleId: eleId, ele:ele });
  }

  onDelete(eleId){
    this.delete(eleId, this.myList.getEleId(eleId));
  }

  onReorder(indexes){
    this.myList.reorder(indexes);
  }

	onSearch(ev: any) {

    this.doFilterRegExp = null;
    try { this.doFilterRegExp = new RegExp(  ev.target.value, 'i' ); } 
    catch(e) { 
      console.log("onSearch RegExp error : " + e );
    }
    this.myList.setFilter( (ele, index, array)=>{return this.doFilter(ele, index, array); } );
  }

  onCancelSearch(ev: any) {
    this.myList.setFilter( null );
  }

  onClearSearch(ev: any) {
    this.myList.setFilter( null );
  }




  addOrUpdate(eleId, ele) : firebase.Promise<any> {
    return this.myList.addOrUpdate(eleId, ele);
  }

  delete(eleId, ele) : firebase.Promise<any> {   
    return this.myList.delete(eleId);
  }










showOptions(eleId, ele) {
  let actionSheet = this.actionSheetCtrl.create({
    title: 'What do you want to do?',
    buttons: [
      {
        text: 'Delete',
        role: 'destructive',
        handler: () => {
          this.onDelete(eleId);
        }
      },{
        text: 'Update title',
        handler: () => {
          this.onUpdate(eleId, ele);
        }
      },{
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }
    ]
  });
  actionSheet.present();
  
}

}


/*
  TODO


  edit direct, ou avec validation ?

    options
      Add, Edit par push page ou alertCtrl

  

Pour Ele
  constructor(public navCtrl: NavController, public navParams: NavParams) avec param parent, eleId, ele
  eleId, ele
  onDeleteEle()
  onAddOrUpdateEle()


Pour Eles
  onAdd
  onUpdate(eleId, ele)
  onDelete(eleId)
  onReorder(indexes)
  onSearch(ev: any)
  addOrUpdate(eleId, ele)
  delete(eleId)

*/


// WEBPACK FOOTER //
// ./src/pages/eles/eles.ts